// extracted by mini-css-extract-plugin
module.exports = {"emptyMessage":"emptyMessage_emptyMessage__3xaf0","image":"emptyMessage_image__OQjSw","content":"emptyMessage_content__jk1kC","vertical":"emptyMessage_vertical__1ZUU_"};